import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ThreadItemComponent from './ThreadItemTemplateComponent';

const ThreadItemContainer = ({ messagesList, chatId, ...rest }) => {
  const threadScope = messagesList?.find(({ id }) => id === chatId)?.scope;
  const isMultiThread = (threadScope && threadScope !== 'personal') || false;

  return <ThreadItemComponent isMultiThread={isMultiThread} {...rest} />;
};

ThreadItemContainer.defaultProps = {
  messagesList: null,
  chatId: null,
};

ThreadItemContainer.propTypes = {
  chatId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  messagesList: PropTypes.instanceOf(Array),
};

const mapStateToProps = ({ messages: { results: messagesList } }) => ({
  messagesList,
});

export default connect(mapStateToProps, null)(ThreadItemContainer);
